<template>
  <div class="addEdit-block">
    <el-form
      class="detail-form-content"
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="80px"
	  :style="{backgroundColor:addEditForm.addEditBoxColor}"
    >
      <el-row >
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('coach.id')" prop="jiaolianbianhao">
          <el-input v-model="ruleForm.jiaolianbianhao" 
              :placeholder="$t('coach.id')" clearable  :readonly="ro.jiaolianbianhao"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('coach.id')" prop="jiaolianbianhao">
              <el-input v-model="ruleForm.jiaolianbianhao" 
                :placeholder="$t('coach.id')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('coach.password')" prop="mima">
          <el-input v-model="ruleForm.mima" 
              :placeholder="$t('coach.password')" clearable  :readonly="ro.mima"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('coach.password')" prop="mima">
              <el-input v-model="ruleForm.mima" 
                :placeholder="$t('coach.password')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('coach.name')" prop="jiaolianxingming">
          <el-input v-model="ruleForm.jiaolianxingming" 
              :placeholder="$t('coach.name')" clearable  :readonly="ro.jiaolianxingming"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('coach.name')" prop="jiaolianxingming">
              <el-input v-model="ruleForm.jiaolianxingming" 
                :placeholder="$t('coach.name')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="select" v-if="type!='info'"  :label="$t('coach.gender')" prop="xingbie">
          <el-select :disabled="ro.xingbie" v-model="ruleForm.xingbie" :placeholder="$t('coach.pleaseSelectGender')">
            <el-option
                v-for="(item,index) in xingbieOptions"
                v-bind:key="index"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('coach.gender')" prop="xingbie">
	      <el-input v-model="ruleForm.xingbie"
                :placeholder="$t('coach.gender')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('coach.age')" prop="nianling">
          <el-input v-model="ruleForm.nianling" 
              :placeholder="$t('coach.age')" clearable  :readonly="ro.nianling"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('coach.age')" prop="nianling">
              <el-input v-model="ruleForm.nianling" 
                :placeholder="$t('coach.age')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('coach.level')" prop="jiaoliandengji">
          <el-input v-model="ruleForm.jiaoliandengji" 
              :placeholder="$t('coach.level')" clearable  :readonly="ro.jiaoliandengji"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('coach.level')" prop="jiaoliandengji">
              <el-input v-model="ruleForm.jiaoliandengji" 
                :placeholder="$t('coach.level')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="12">
        <el-form-item class="input" v-if="type!='info'"  :label="$t('coach.phone')" prop="lianxidianhua">
          <el-input v-model="ruleForm.lianxidianhua" 
              :placeholder="$t('coach.phone')" clearable  :readonly="ro.lianxidianhua"></el-input>
        </el-form-item>
        <div v-else>
          <el-form-item class="input" :label="$t('coach.phone')" prop="lianxidianhua">
              <el-input v-model="ruleForm.lianxidianhua" 
                :placeholder="$t('coach.phone')" readonly></el-input>
          </el-form-item>
        </div>
      </el-col>
      <el-col :span="24">  
        <el-form-item class="upload" v-if="type!='info' && !ro.touxiang" :label="$t('coach.image')" prop="touxiang">
          <file-upload
          :tip="$t('coach.clickUploadImage')"
          action="file/upload"
          :limit="3"
          :multiple="true"
          :fileUrls="ruleForm.touxiang?ruleForm.touxiang:''"
          @change="touxiangUploadChange"
          ></file-upload>
        </el-form-item>
        <div v-else>
          <el-form-item v-if="ruleForm.touxiang" :label="$t('coach.image')" prop="touxiang">
            <img style="margin-right:20px;" v-bind:key="index" v-for="(item,index) in ruleForm.touxiang.split(',')" :src="$base.imgurl+item" width="100" height="100">
          </el-form-item>
        </div>
      </el-col>
      
      <!-- 健身项目选择 - 仅在添加/编辑模式下显示 -->
      <el-col :span="24" v-if="type!='info'">
        <el-form-item :label="$t('coach.assignedProjects')" prop="selectedProjects">
          <el-transfer
            v-model="selectedProjects"
            :data="allProjects"
            :titles="[$t('coach.allProjects'), $t('coach.assignedProjects')]"
            :button-texts="[$t('transfer.remove'), $t('transfer.add')]"
            :render-content="renderProjectContent"
            :props="{
              key: 'xiangmumingcheng',
              label: 'xiangmumingcheng'
            }"
            filterable
            :filter-placeholder="$t('coach.searchProjects')">
          </el-transfer>
        </el-form-item>
      </el-col>
      </el-row>
      <el-form-item class="btn">
        <el-button  v-if="type!='info'" type="primary" class="btn-success" @click="onSubmit">{{ $t('common.submit') }}</el-button>
        <el-button v-if="type!='info'" class="btn-close" @click="back()">{{ $t('common.cancel') }}</el-button>
        <el-button v-if="type=='info'" class="btn-close" @click="back()">{{ $t('common.back') }}</el-button>
      </el-form-item>
    </el-form>
    
    <!-- 健身项目 - 仅在详情模式下显示 -->
    <div v-if="type === 'info'" class="fitness-projects">
      <el-divider content-position="left">
        <span style="font-weight: bold; font-size: 16px;">{{ $t('missingTranslations.fitnessProjects') }}</span>
      </el-divider>
      
      <el-table 
        :data="projectList" 
        v-loading="projectLoading"
        border
        style="width: 100%; margin-top: 20px;">
        <el-table-column type="index" :label="$t('common.index')" width="60"></el-table-column>
        <el-table-column prop="xiangmumingcheng" :label="$t('fitnessProject.projectName')" width="150"></el-table-column>
        <el-table-column prop="xiangmuleixing" :label="$t('fitnessProject.projectType')" width="120"></el-table-column>
        <el-table-column prop="xiangmutupian" :label="$t('fitnessProject.projectImage')" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.xiangmutupian" :src="$base.imgurl + scope.row.xiangmutupian" style="width: 50px; height: 50px; object-fit: cover;">
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="jiage" :label="$t('common.price')" width="100">
          <template slot-scope="scope">
            ¥{{ scope.row.jiage }}
          </template>
        </el-table-column>
        <el-table-column prop="xiangmujieshao" :label="$t('missingTranslations.projectDetails')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="addtime" :label="$t('sale.createTime')" width="160">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.addtime) }}
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 项目统计信息 -->
      <div class="project-summary" style="margin-top: 20px; padding: 15px; background: #f5f7fa; border-radius: 8px;">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="summary-item">
              <div class="summary-label">{{ $t('missingTranslations.projectCount') }}</div>
              <div class="summary-value">{{ projectStats.totalCount }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="summary-item">
              <div class="summary-label">{{ $t('fitnessProject.projectType') }}</div>
              <div class="summary-value" style="color: #409EFF;">{{ projectStats.projectTypes }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="summary-item">
              <div class="summary-label">{{ $t('missingTranslations.avgPrice') }}</div>
              <div class="summary-value" style="color: #67C23A;">¥{{ projectStats.avgPrice }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    
    <!-- 预约记录 - 仅在详情模式下显示 -->
    <div v-if="type === 'info'" class="appointment-records">
      <el-divider content-position="left">
        <span style="font-weight: bold; font-size: 16px;">{{ $t('missingTranslations.appointmentRecords') }}</span>
      </el-divider>
      
      <el-table 
        :data="appointmentList" 
        v-loading="appointmentLoading"
        border
        style="width: 100%; margin-top: 20px;">
        <el-table-column type="index" :label="$t('common.index')" width="60"></el-table-column>
        <el-table-column prop="xingming" :label="$t('user.name')" width="120"></el-table-column>
        <el-table-column prop="zhanghao" :label="$t('user.account')" width="120"></el-table-column>
        <el-table-column prop="startTime" :label="$t('appointment.startTime')" width="160">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.startTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="endTime" :label="$t('appointment.endTime')" width="160">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.endTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="duration" :label="$t('appointment.duration')" width="80"></el-table-column>
        <el-table-column prop="price" :label="$t('common.price')" width="80">
          <template slot-scope="scope">
            ¥{{ scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column prop="xiangmumingcheng" label="项目名称" width="150"></el-table-column>
        <el-table-column prop="xiangmufenlei" label="项目类型" width="120"></el-table-column>
        <el-table-column prop="status" :label="$t('missingTranslations.completionStatus')" width="100">
          <template slot-scope="scope">
            <el-tag 
              :type="scope.row.status === 'complete' ? 'success' : 
                     scope.row.status === 'reject' ? 'danger' : 
                     scope.row.status === 'pending' ? 'warning' : 'info'"
              size="small">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="paymentStatus" :label="$t('appointment.paymentStatus')" width="100">
          <template slot-scope="scope">
            <el-tag 
              :type="scope.row.paymentStatus === 1 ? 'success' : 
                     scope.row.paymentStatus === 2 ? 'danger' : 'warning'"
              size="small">
              {{ scope.row.paymentStatus === 1 ? $t('appointment.paid') : 
                 scope.row.paymentStatus === 2 ? $t('appointment.cancelled') : $t('appointment.pendingPayment') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="yuyueshuoming" :label="$t('appointment.description')" show-overflow-tooltip></el-table-column>
        <el-table-column prop="addtime" :label="$t('sale.createTime')" width="160">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.addtime) }}
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 预约统计信息 -->
      <div class="appointment-summary" style="margin-top: 20px; padding: 15px; background: #f5f7fa; border-radius: 8px;">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="summary-item">
              <div class="summary-label">{{ $t('missingTranslations.totalAppointments') }}</div>
              <div class="summary-value">{{ appointmentStats.totalCount }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <div class="summary-label">{{ $t('appointment.completed') }}</div>
              <div class="summary-value" style="color: #67C23A;">{{ appointmentStats.completedCount }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <div class="summary-label">{{ $t('roomcleaning.pending') }}</div>
              <div class="summary-value" style="color: #E6A23C;">{{ appointmentStats.pendingCount }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="summary-item">
              <div class="summary-label">{{ $t('reportCenter.totalRevenue') }}</div>
              <div class="summary-value" style="color: #409EFF;">¥{{ appointmentStats.totalAmount }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

  </div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
  data() {
    let self = this
    var validateIdCard = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!checkIdCard(value)) {
        callback(new Error("请输入正确的身份证号码"));
      } else {
        callback();
      }
    };
    var validateUrl = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isURL(value)) {
        callback(new Error("请输入正确的URL地址"));
      } else {
        callback();
      }
    };
    var validateMobile = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isMobile(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isPhone(value)) {
        callback(new Error("请输入正确的电话号码"));
      } else {
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isEmail(value)) {
        callback(new Error("请输入正确的邮箱地址"));
      } else {
        callback();
      }
    };
    var validateNumber = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isNumber(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    var validateIntNumber = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isIntNumer(value)) {
        callback(new Error("请输入整数"));
      } else {
        callback();
      }
    };
    return {
	  addEditForm: {"btnSaveFontColor":"#fff","selectFontSize":"14px","btnCancelBorderColor":"#DCDFE6","inputBorderRadius":"4px","inputFontSize":"14px","textareaBgColor":"#fff","btnSaveFontSize":"14px","textareaBorderRadius":"4px","uploadBgColor":"#fff","textareaBorderStyle":"solid","btnCancelWidth":"88px","textareaHeight":"120px","dateBgColor":"#fff","btnSaveBorderRadius":"4px","uploadLableFontSize":"14px","textareaBorderWidth":"3px","inputLableColor":"rgba(0, 0, 0, 1)","addEditBoxColor":"rgba(255, 255, 255, 0)","dateIconFontSize":"14px","btnSaveBgColor":"rgba(64, 158, 255, 1)","uploadIconFontColor":"rgba(119, 197, 227, 1)","textareaBorderColor":"rgba(119, 197, 227, 1)","btnCancelBgColor":"rgba(64, 158, 255, 1)","selectLableColor":"rgba(0, 0, 0, 1)","btnSaveBorderStyle":"solid","dateBorderWidth":"3px","dateLableFontSize":"14px","dateBorderRadius":"4px","btnCancelBorderStyle":"solid","selectLableFontSize":"14px","selectBorderStyle":"solid","selectIconFontColor":"rgba(0, 0, 0, 1)","btnCancelHeight":"44px","inputHeight":"45px","btnCancelFontColor":"rgba(255, 255, 255, 1)","dateBorderColor":"rgba(119, 197, 227, 1)","dateIconFontColor":"rgba(0, 0, 0, 1)","uploadBorderStyle":"solid","dateBorderStyle":"solid","dateLableColor":"rgba(0, 4, 11, 1)","dateFontSize":"14px","inputBorderWidth":"3px","uploadIconFontSize":"28px","selectHeight":"40px","inputFontColor":"rgba(0, 0, 0, 1)","uploadHeight":"148px","textareaLableColor":"rgba(0, 0, 0, 1)","textareaLableFontSize":"14px","btnCancelFontSize":"14px","inputBorderStyle":"solid","btnCancelBorderRadius":"4px","inputBgColor":"#fff","inputLableFontSize":"14px","uploadLableColor":"rgba(0, 0, 0, 1)","uploadBorderRadius":"4px","btnSaveHeight":"44px","selectBgColor":"#fff","btnSaveWidth":"88px","selectIconFontSize":"14px","dateHeight":"45px","selectBorderColor":"rgba(119, 197, 227, 1)","inputBorderColor":"rgba(119, 197, 227, 1)","uploadBorderColor":"rgba(119, 197, 227, 1)","textareaFontColor":"rgba(0, 0, 0, 1)","selectBorderWidth":"3px","dateFontColor":"rgba(0, 1, 2, 1)","btnCancelBorderWidth":"0","uploadBorderWidth":"3px","textareaFontSize":"15px","selectBorderRadius":"4px","selectFontColor":"rgba(0, 0, 0, 1)","btnSaveBorderColor":"rgba(64, 158, 255, 1)","btnSaveBorderWidth":"0"},
      id: '',
      type: '',
      ro:{
	jiaolianbianhao : false,
	mima : false,
	jiaolianxingming : false,
	xingbie : false,
	nianling : false,
	jiaoliandengji : false,
	lianxidianhua : false,
	touxiang : false,
      },
      ruleForm: {
        jiaolianbianhao: '',
        mima: '',
        jiaolianxingming: '',
        xingbie: '',
        nianling: '',
        jiaoliandengji: '',
        lianxidianhua: '',
        touxiang: '',
      },
          xingbieOptions: [],
      rules: {
          jiaolianbianhao: [
                { required: true, message: '教练编号不能为空', trigger: 'blur' },
          ],
          mima: [
                { required: true, message: '密码不能为空', trigger: 'blur' },
          ],
          jiaolianxingming: [
                { required: true, message: '教练姓名不能为空', trigger: 'blur' },
          ],
          xingbie: [
          ],
          nianling: [
                { validator: validateIntNumber, trigger: 'blur' },
          ],
          jiaoliandengji: [
          ],
          lianxidianhua: [
                { validator: validateMobile, trigger: 'blur' },
          ],
          touxiang: [
          ],
      },
      projectList: [],
      projectLoading: false,
      projectStats: {
        totalCount: 0,
        projectTypes: '',
        avgPrice: 0
      },
      appointmentList: [],
      appointmentLoading: false,
      appointmentStats: {
        totalCount: 0,
        completedCount: 0,
        pendingCount: 0,
        totalAmount: 0
      },
      allProjects: [], // 所有健身项目列表
      selectedProjects: [] // 当前教练负责的项目
    };
  },
  props: ["parent"],
  computed: {



  },
  created() {
	this.addEditStyleChange()
	this.addEditUploadStyleChange()
  },
  methods: {
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 初始化
    init(id,type) {
      if (id) {
        this.id = id;
        this.type = type;
      }
      
      // 加载所有健身项目
      this.loadAllProjects();
      
      if(this.type=='info'||this.type=='else'){
        this.info(id);
      }else if(this.type=='logistics'){
        this.logistics=false;
        this.info(id);
      }else if(this.type=='cross'){
        var obj = this.$storage.getObj('crossObj');
        for (var o in obj){
          if(o=='jiaolianbianhao'){
            this.ruleForm.jiaolianbianhao = obj[o];
	    this.ro.jiaolianbianhao = true;
            continue;
          }
          if(o=='mima'){
            this.ruleForm.mima = obj[o];
	    this.ro.mima = true;
            continue;
          }
          if(o=='jiaolianxingming'){
            this.ruleForm.jiaolianxingming = obj[o];
	    this.ro.jiaolianxingming = true;
            continue;
          }
          if(o=='xingbie'){
            this.ruleForm.xingbie = obj[o];
	    this.ro.xingbie = true;
            continue;
          }
          if(o=='nianling'){
            this.ruleForm.nianling = obj[o];
	    this.ro.nianling = true;
            continue;
          }
          if(o=='jiaoliandengji'){
            this.ruleForm.jiaoliandengji = obj[o];
	    this.ro.jiaoliandengji = true;
            continue;
          }
          if(o=='lianxidianhua'){
            this.ruleForm.lianxidianhua = obj[o];
	    this.ro.lianxidianhua = true;
            continue;
          }
          if(o=='touxiang'){
            this.ruleForm.touxiang = obj[o];
	    this.ro.touxiang = true;
            continue;
          }
        }
      }
      // 获取用户信息
      this.$http({
        url: `${this.$storage.get('sessionTable')}/session`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          var json = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
            this.xingbieOptions = "男,女".split(',')
    },
    // 多级联动参数
    info(id) {
      this.$http({
        url: `jiaolian/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
        
        // 加载教练的项目关联
        this.loadCoachProjects();
        
	//解决前台上传图片后台不显示的问题
	let reg=new RegExp('../../../upload','g')//g代表全部
	
	// 如果是详情模式，获取健身项目和预约记录
	if (this.type === 'info') {
	  this.getFitnessProjects(id);
	  this.getAppointmentRecords(id);
	}
        } else {
          this.$message.error(data.msg);
        }
      });
    },


    // 提交
    onSubmit() {
















	if(this.ruleForm.touxiang!=null) {
    console.log('头像数据:', this.ruleForm.touxiang);
    
		this.ruleForm.touxiang = this.ruleForm.touxiang.replace(new RegExp(this.$base.url,"g"),"");
	}

var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
       var crossuserid;
       var crossrefid;
       var crossoptnum;
       if(this.type=='cross'){
                var statusColumnName = this.$storage.get('statusColumnName');
                var statusColumnValue = this.$storage.get('statusColumnValue');
                if(statusColumnName!='') {
                        var obj = this.$storage.getObj('crossObj');
                       if(!statusColumnName.startsWith("[")) {
                               for (var o in obj){
                                 if(o==statusColumnName){
                                   obj[o] = statusColumnValue;
                                 }
                               }
                               var table = this.$storage.get('crossTable');
                             this.$http({
                                 url: `${table}/update`,
                                 method: "post",
                                 data: obj
                               }).then(({ data }) => {});
                       } else {
                               crossuserid=this.$storage.get('userid');
                               crossrefid=obj['id'];
                               crossoptnum=this.$storage.get('statusColumnName');
                               crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
                        }
                }
        }
       this.$refs["ruleForm"].validate(valid => {
         if (valid) {
          // 添加控制台日志，确认头像数据
      console.log('提交的头像数据:', this.ruleForm.touxiang);
      
		 if(crossrefid && crossuserid) {
			 this.ruleForm.crossuserid = crossuserid;
			 this.ruleForm.crossrefid = crossrefid;
			let params = { 
				page: 1, 
				limit: 10, 
				crossuserid:this.ruleForm.crossuserid,
				crossrefid:this.ruleForm.crossrefid,
			} 
			this.$http({ 
				url: "jiaolian/page", 
				method: "get", 
				params: params 
			}).then(({ 
				data 
			}) => { 
				if (data && data.code === 0) { 
				       if(data.data.total>=crossoptnum) {
					     this.$message.error(this.$storage.get('tips'));
					       return false;
				       } else {
					 this.$http({
					   url: `jiaolian/${!this.ruleForm.id ? "save" : "update"}`,
					   method: "post",
					   data: this.ruleForm
					 }).then(({ data }) => {
					   if (data && data.code === 0) {
					     // 保存教练项目关联
					     this.saveCoachProjects().then(() => {
					       this.$message({
					         message: "操作成功",
					         type: "success",
					         duration: 1500,
					         onClose: () => {
						   this.parent.showFlag = true;
						   this.parent.addOrUpdateFlag = false;
						   this.parent.jiaolianCrossAddOrUpdateFlag = false;
						   this.parent.search();
						   this.parent.contentStyleChange();
					         }
					       });
					     });
					   } else {
					     this.$message.error(data.msg);
					   }
					 });

				       }
				} else { 
				} 
			});
		 } else {
			 this.$http({
			   url: `jiaolian/${!this.ruleForm.id ? "save" : "update"}`,
			   method: "post",
			   data: this.ruleForm
			 }).then(({ data }) => {
			   if (data && data.code === 0) {
			     // 保存教练项目关联
			     this.saveCoachProjects().then(() => {
			       this.$message({
			         message: "操作成功",
			         type: "success",
			         duration: 1500,
			         onClose: () => {
				   this.parent.showFlag = true;
				   this.parent.addOrUpdateFlag = false;
				   this.parent.jiaolianCrossAddOrUpdateFlag = false;
				   this.parent.search();
				   this.parent.contentStyleChange();
			         }
			       });
			     });
			   } else {
			     this.$message.error(data.msg);
			   }
			 });
		 }
         }
       });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.jiaolianCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
    touxiangUploadChange(fileUrls) {
       // 添加控制台日志，确认上传回调
  console.log('头像上传回调，文件URL:', fileUrls);
	this.ruleForm.touxiang = fileUrls;
	this.addEditUploadStyleChange()
  // 添加控制台日志，确认表单数据更新
  console.log('更新后的表单头像数据:', this.ruleForm.touxiang);
    },
	addEditStyleChange() {
	  this.$nextTick(()=>{
	    // input
	    document.querySelectorAll('.addEdit-block .input .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.inputHeight
	      el.style.color = this.addEditForm.inputFontColor
	      el.style.fontSize = this.addEditForm.inputFontSize
	      el.style.borderWidth = this.addEditForm.inputBorderWidth
	      el.style.borderStyle = this.addEditForm.inputBorderStyle
	      el.style.borderColor = this.addEditForm.inputBorderColor
	      el.style.borderRadius = this.addEditForm.inputBorderRadius
	      el.style.backgroundColor = this.addEditForm.inputBgColor
	    })
	    document.querySelectorAll('.addEdit-block .input .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.inputHeight
	      el.style.color = this.addEditForm.inputLableColor
	      el.style.fontSize = this.addEditForm.inputLableFontSize
	    })
	    // select
	    document.querySelectorAll('.addEdit-block .select .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.selectHeight
	      el.style.color = this.addEditForm.selectFontColor
	      el.style.fontSize = this.addEditForm.selectFontSize
	      el.style.borderWidth = this.addEditForm.selectBorderWidth
	      el.style.borderStyle = this.addEditForm.selectBorderStyle
	      el.style.borderColor = this.addEditForm.selectBorderColor
	      el.style.borderRadius = this.addEditForm.selectBorderRadius
	      el.style.backgroundColor = this.addEditForm.selectBgColor
	    })
	    document.querySelectorAll('.addEdit-block .select .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.selectHeight
	      el.style.color = this.addEditForm.selectLableColor
	      el.style.fontSize = this.addEditForm.selectLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .select .el-select__caret').forEach(el=>{
	      el.style.color = this.addEditForm.selectIconFontColor
	      el.style.fontSize = this.addEditForm.selectIconFontSize
	    })
	    // date
	    document.querySelectorAll('.addEdit-block .date .el-input__inner').forEach(el=>{
	      el.style.height = this.addEditForm.dateHeight
	      el.style.color = this.addEditForm.dateFontColor
	      el.style.fontSize = this.addEditForm.dateFontSize
	      el.style.borderWidth = this.addEditForm.dateBorderWidth
	      el.style.borderStyle = this.addEditForm.dateBorderStyle
	      el.style.borderColor = this.addEditForm.dateBorderColor
	      el.style.borderRadius = this.addEditForm.dateBorderRadius
	      el.style.backgroundColor = this.addEditForm.dateBgColor
	    })
	    document.querySelectorAll('.addEdit-block .date .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.dateHeight
	      el.style.color = this.addEditForm.dateLableColor
	      el.style.fontSize = this.addEditForm.dateLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .date .el-input__icon').forEach(el=>{
	      el.style.color = this.addEditForm.dateIconFontColor
	      el.style.fontSize = this.addEditForm.dateIconFontSize
	      el.style.lineHeight = this.addEditForm.dateHeight
	    })
	    // upload
	    let iconLineHeight = parseInt(this.addEditForm.uploadHeight) - parseInt(this.addEditForm.uploadBorderWidth) * 2 + 'px'
	    document.querySelectorAll('.addEdit-block .upload .el-upload--picture-card').forEach(el=>{
	      el.style.width = this.addEditForm.uploadHeight
	      el.style.height = this.addEditForm.uploadHeight
	      el.style.borderWidth = this.addEditForm.uploadBorderWidth
	      el.style.borderStyle = this.addEditForm.uploadBorderStyle
	      el.style.borderColor = this.addEditForm.uploadBorderColor
	      el.style.borderRadius = this.addEditForm.uploadBorderRadius
	      el.style.backgroundColor = this.addEditForm.uploadBgColor
	    })
	    document.querySelectorAll('.addEdit-block .upload .el-form-item__label').forEach(el=>{
	      el.style.lineHeight = this.addEditForm.uploadHeight
	      el.style.color = this.addEditForm.uploadLableColor
	      el.style.fontSize = this.addEditForm.uploadLableFontSize
	    })
	    document.querySelectorAll('.addEdit-block .upload .el-icon-plus').forEach(el=>{
	      el.style.color = this.addEditForm.uploadIconFontColor
	      el.style.fontSize = this.addEditForm.uploadIconFontSize
	      el.style.lineHeight = iconLineHeight
	      el.style.display = 'block'
	    })
	    // 多文本输入框
	    document.querySelectorAll('.addEdit-block .textarea .el-textarea__inner').forEach(el=>{
	      el.style.height = this.addEditForm.textareaHeight
	      el.style.color = this.addEditForm.textareaFontColor
	      el.style.fontSize = this.addEditForm.textareaFontSize
	      el.style.borderWidth = this.addEditForm.textareaBorderWidth
	      el.style.borderStyle = this.addEditForm.textareaBorderStyle
	      el.style.borderColor = this.addEditForm.textareaBorderColor
	      el.style.borderRadius = this.addEditForm.textareaBorderRadius
	      el.style.backgroundColor = this.addEditForm.textareaBgColor
	    })
	    document.querySelectorAll('.addEdit-block .textarea .el-form-item__label').forEach(el=>{
	      // el.style.lineHeight = this.addEditForm.textareaHeight
	      el.style.color = this.addEditForm.textareaLableColor
	      el.style.fontSize = this.addEditForm.textareaLableFontSize
	    })
	    // 保存
	    document.querySelectorAll('.addEdit-block .btn .btn-success').forEach(el=>{
	      el.style.width = this.addEditForm.btnSaveWidth
	      el.style.height = this.addEditForm.btnSaveHeight
	      el.style.color = this.addEditForm.btnSaveFontColor
	      el.style.fontSize = this.addEditForm.btnSaveFontSize
	      el.style.borderWidth = this.addEditForm.btnSaveBorderWidth
	      el.style.borderStyle = this.addEditForm.btnSaveBorderStyle
	      el.style.borderColor = this.addEditForm.btnSaveBorderColor
	      el.style.borderRadius = this.addEditForm.btnSaveBorderRadius
	      el.style.backgroundColor = this.addEditForm.btnSaveBgColor
	    })
	    // 返回
	    document.querySelectorAll('.addEdit-block .btn .btn-close').forEach(el=>{
	      el.style.width = this.addEditForm.btnCancelWidth
	      el.style.height = this.addEditForm.btnCancelHeight
	      el.style.color = this.addEditForm.btnCancelFontColor
	      el.style.fontSize = this.addEditForm.btnCancelFontSize
	      el.style.borderWidth = this.addEditForm.btnCancelBorderWidth
	      el.style.borderStyle = this.addEditForm.btnCancelBorderStyle
	      el.style.borderColor = this.addEditForm.btnCancelBorderColor
	      el.style.borderRadius = this.addEditForm.btnCancelBorderRadius
	      el.style.backgroundColor = this.addEditForm.btnCancelBgColor
	    })
	  })
	},
	addEditUploadStyleChange() {
		this.$nextTick(()=>{
		  document.querySelectorAll('.addEdit-block .upload .el-upload-list--picture-card .el-upload-list__item').forEach(el=>{
			el.style.width = this.addEditForm.uploadHeight
			el.style.height = this.addEditForm.uploadHeight
			el.style.borderWidth = this.addEditForm.uploadBorderWidth
			el.style.borderStyle = this.addEditForm.uploadBorderStyle
			el.style.borderColor = this.addEditForm.uploadBorderColor
			el.style.borderRadius = this.addEditForm.uploadBorderRadius
			el.style.backgroundColor = this.addEditForm.uploadBgColor
		  })
	  })
	},
    formatDateTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    getStatusText(status) {
      switch (status) {
        case 'complete':
          return '已完成';
        case 'reject':
          return '已拒绝';
        case 'pending':
          return '待处理';
        default:
          return status;
      }
    },

    // 获取教练的健身项目
    // async getFitnessProjects(coachId) {
    //   this.projectLoading = true;
    //   try {
    //     // 先获取所有健身项目，然后在前端过滤出该教练负责的项目
    //     const { data } = await this.$http({
    //       url: 'jianshenxiangmu/page',
    //       method: 'get',
    //       params: {
    //         page: 1,
    //         limit: 1000 // 获取所有项目
    //       }
    //     });

    //     if (data && data.code === 0) {
    //       this.allProjects = data.data.list || [];
    //       // 过滤出该教练负责的项目（通过教练姓名匹配）
    //       this.selectedProjects = this.allProjects.filter(project => {
    //         if (project.coachIds && Array.isArray(project.coachIds)) {
    //           return project.coachIds.some(coach => 
    //             coach.jiaolianxingming === this.ruleForm.jiaolianxingming ||
    //             coach.jiaolianbianhao === this.ruleForm.jiaolianbianhao
    //           );
    //         }
    //         return false;
    //       });
    //       this.calculateProjectStats();
    //     } else {
    //       this.$message.error(data.msg || '获取健身项目失败');
    //     }
    //   } catch (error) {
    //     console.error('获取健身项目失败:', error);
    //     this.$message.error('获取健身项目失败');
    //   } finally {
    //     this.projectLoading = false;
    //   }
    // },
    // 获取教练的健身项目
async getFitnessProjects(coachId) {
  this.projectLoading = true;
   try {
         const res = await this.$http({
           url: `/jiaolian/${this.ruleForm.jiaolianbianhao}/projectIds`,
           method: 'get'
         });
         if (res.data && res.data.code === 0) {
           this.projectList = res.data.data || [];
 this.calculateProjectStats();         }
       }
       catch (error) {
    console.error('获取健身项目失败:', error);
    this.$message.error('获取健身项目失败');
    this.projectList = []; // 确保在出错时设置为空数组
  } finally {
    this.projectLoading = false;
  }
  // try {
  //   // 直接获取教练负责的项目
  //   const { data } = await this.$http({
  //     url: `/jiaolian/${this.ruleForm.jiaolianbianhao}/projects`,
  //     method: 'get',
  //     params: {
  //       page: 1,
  //       limit: 1000
  //     }
  //   });

  //   if (data && data.code === 0) {
  //     this.projectList = data.data.list || [];
  //     this.calculateProjectStats();
  //   } else {
  //     this.$message.error(data.msg || '获取健身项目失败');
  //     this.projectList = []; // 确保在没有数据时设置为空数组
  //   }
  // } catch (error) {
  //   console.error('获取健身项目失败:', error);
  //   this.$message.error('获取健身项目失败');
  //   this.projectList = []; // 确保在出错时设置为空数组
  // } finally {
  //   this.projectLoading = false;
  // }
},


    // 计算项目统计信息
    calculateProjectStats() {
      const stats = {
        totalCount: this.projectList.length,
        projectTypes: '',
        avgPrice: 0
      };

              if (this.projectList.length > 0) {
          // 统计项目类型
          const types = [...new Set(this.projectList.map(p => p.xiangmuleixing).filter(t => t))];
          stats.projectTypes = types.join(', ') || '无';

          // 计算平均价格
          const totalPrice = this.projectList.reduce((sum, project) => {
            return sum + (parseFloat(project.jiage) || 0);
          }, 0);
          stats.avgPrice = totalPrice > 0 ? (totalPrice / this.projectList.length).toFixed(2) : 0;
        }

      this.projectStats = stats;
    },

    // 获取教练的预约记录
    async getAppointmentRecords(coachId) {
      this.appointmentLoading = true;
      try {
        const { data } = await this.$http({
          url: 'jiaolianyuyue/page',
          method: 'get',
          params: {
            page: 1,
            limit: 1000, // 获取所有记录
            jiaolianbianhao: this.ruleForm.jiaolianbianhao // 使用教练编号查询
          }
        });

        if (data && data.code === 0) {
          this.appointmentList = data.data.list || [];
          this.calculateAppointmentStats();
        } else {
          this.$message.error(data.msg || '获取预约记录失败');
        }
      } catch (error) {
        console.error('获取预约记录失败:', error);
        this.$message.error('获取预约记录失败');
      } finally {
        this.appointmentLoading = false;
      }
    },

    // 计算预约统计信息
    calculateAppointmentStats() {
      const stats = {
        totalCount: this.appointmentList.length,
        completedCount: 0,
        pendingCount: 0,
        totalAmount: 0
      };

      this.appointmentList.forEach(appointment => {
        // 统计状态
        if (appointment.status === 'complete') {
          stats.completedCount++;
        } else if (appointment.status === 'pending') {
          stats.pendingCount++;
        }

        // 计算总收入（只计算已支付的）
        if (appointment.paymentStatus === 1 && appointment.price) {
          stats.totalAmount += parseFloat(appointment.price) || 0;
        }
      });

      this.appointmentStats = stats;
    },

         // 渲染项目内容
     renderProjectContent(h, option) {
       return h('span', { style: 'margin-left: 10px' }, [
         h('span', option.xiangmumingcheng),
         h('span', { style: 'margin-left: 10px; color: #909399; font-size: 12px' }, option.xiangmuleixing)
       ]);
     },

     // 加载所有健身项目
     async loadAllProjects() {
       try {
         const res = await this.$http({
           url: '/jianshenxiangmu/list',
           method: 'get',
           params: {
             page: 1,
             limit: 1000
           }
         });
         if (res.data && res.data.code === 0) {
           this.allProjects = res.data.data.list || [];
         }
       } catch (error) {
         console.error('加载健身项目失败:', error);
       }
     },

     // 加载教练的健身项目
     async loadCoachProjects() {
       if (!this.ruleForm.jiaolianbianhao) return;
       
       try {
         const res = await this.$http({
           url: `/jiaolian/${this.ruleForm.jiaolianbianhao}/projectIds`,
           method: 'get'
         });
         if (res.data && res.data.code === 0) {
           const coachProjects = res.data.data || [];
           this.selectedProjects = coachProjects.map(project => project.xiangmumingcheng);
         }
       } catch (error) {
         console.error('加载教练项目失败:', error);
       }
     },

     // 保存教练项目关联
     async saveCoachProjects() {
       if (!this.ruleForm.jiaolianbianhao) return Promise.resolve();
       
       try {
         const res = await this.$http({
           url: `/jiaolian/${this.ruleForm.jiaolianbianhao}/updateCoaches`,
           method: 'post',
           data: this.selectedProjects
         });
         if (res.data && res.data.code === 0) {
           console.log('教练项目关联更新成功');
         } else {
           console.error('教练项目关联更新失败:', res.data.msg);
         }
       } catch (error) {
         console.error('保存教练项目关联失败:', error);
       }
       return Promise.resolve();
     }
  }
};
</script>
<style lang="scss">
.editor{
  height: 500px;
  
  & /deep/ .ql-container {
	  height: 310px;
  }
}
.amap-wrapper {
  width: 100%;
  height: 500px;
}
.search-box {
  position: absolute;
}
.addEdit-block {
	margin: -10px;
}
.detail-form-content {
	padding: 12px;
	background-color: transparent;
}
.btn .el-button {
  padding: 0;
}

/* 健身项目和预约记录样式 */
.fitness-projects,
.appointment-records {
  margin-top: 30px;
}

.summary-item {
  text-align: center;
  padding: 10px;
}

.summary-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
}

.summary-value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.project-summary,
.appointment-summary {
  margin-top: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
}

.el-divider__text {
  background-color: #fff;
  padding: 0 20px;
}
</style>
